import { render, staticRenderFns } from "./UpdateRolePage.vue?vue&type=template&id=d62012dc&scoped=true"
import script from "./UpdateRolePage.vue?vue&type=script&lang=js"
export * from "./UpdateRolePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62012dc",
  null
  
)

export default component.exports